import React from 'react';
import { ReactComponent as CrossIcon } from 'Assets/usageAnalytics/cross-icon.svg';
import 'Styles/popup/_infoDropDownWithImg.scss';

const InfoDropDownWithImg = ({
  closeInfoDropdownPopUp,
  title = '',
  imageComponent: Image = '',
  descriptionContent = '',
  wrapperClassName = '',
  wrapperMaskClassName = '',
  isSvg = false,
}) => {
  return (
    <>
      <div
        onClick={e => e.stopPropagation()}
        className={`info-dropdown-with-image-wrapper ${wrapperClassName}`}
      >
        <span className="sharp-point" />
        <div className="info-drop-down-wrapper">
          <div className="image-wrapper">
            {isSvg ? (
              <Image />
            ) : (
              Image && <img src={Image} alt={title} className="svg-icon" />
            )}
            <CrossIcon
              className="cross-icon"
              onClick={closeInfoDropdownPopUp}
            />
          </div>
          {title !== '' && <h4>{title}</h4>}
          {descriptionContent !== '' && (
            <div className="description-content">{descriptionContent}</div>
          )}
        </div>
      </div>
      <div
        className={`info-dropdown-with-image-mask ${wrapperMaskClassName}`}
      />
    </>
  );
};

export default InfoDropDownWithImg;
